module.exports = __webpack_public_path__ + "img/telescope.d552b669.svg";